import { render, staticRenderFns } from "./e-dialog.vue?vue&type=template&id=136f38bd&scoped=true"
import script from "./e-dialog.vue?vue&type=script&lang=js"
export * from "./e-dialog.vue?vue&type=script&lang=js"
import style0 from "./e-dialog.vue?vue&type=style&index=0&id=136f38bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136f38bd",
  null
  
)

export default component.exports